import React, { Component } from 'react';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemPanel,
    AccordionItemButton
} from 'react-accessible-accordion';
import DocumentUploader from '../dropzone';
import ViewUploadedFiles from '../ViewUploadeFiles';
import { inject, observer } from 'mobx-react';

@inject('businessProfileStore')
@observer
class CompanyDocuments extends Component {
    handleRemoveDocument = (e, documentId) => {
        const {
            companyProfile
        } = this.props.businessProfileStore.businessProfile.companyDetails;
        const companyProfileData = companyProfile.filter(
            document => document.id !== documentId
        );
        this.props.businessProfileStore.businessProfile.companyDetails.companyProfile = companyProfileData;
    };

    render() {
        const { companyDetails } = this.props.businessProfileStore.businessProfile;
        let id = '';
        let companyProfile = [];

        if (companyDetails) {
            companyProfile = companyDetails.companyProfile || [];
            id = companyDetails.id;
        }

        let fileInfo = {};

        if (id) {
            fileInfo = {
                files: [],
                path: '/public/upload',
                refId: id,
                ref: 'companydetails',
                source: 'content-manager',
                field: 'companyProfile'
            };
        }

        const MAX_DOCUMENTS = 2;
        const totalDocuments = companyProfile.length;
        const remainingSlots = MAX_DOCUMENTS - totalDocuments;

        return (
            <div>
                <Accordion allowZeroExpanded={true}>
                    <AccordionItem>
                        <AccordionItemHeading>
                            <AccordionItemButton>
                                Company Profile & Company Share Register (2 Documents Required)
                            </AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            {remainingSlots > 0 && id && this.props.isDocumentUploadVisible && (
                                <DocumentUploader
                                    fileData={fileInfo}
                                    maxFiles={remainingSlots}
                                    multiple={true}
                                    inputContent={'Upload Company Profile and Share Register'}
                                />
                            )}
                            <div className="row justify-content-center mt-2">
                                {companyProfile.length > 0 && (
                                    <ViewUploadedFiles
                                        title="Uploaded Documents"
                                        data={companyProfile}
                                        handleRemoveDocument={this.handleRemoveDocument}
                                    />
                                )}
                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
            </div>
        );
    }
}

export default CompanyDocuments;
